import React from "react";

// ✅ Ajouter onOpenSimulator dans les props
export default function ExecutiveMail({ onRead, onOpenSimulator }) {
  return (
    <div className="p-6">
      <div className="max-w-3xl mx-auto">
        {/* Mail Header */}
        <div className="bg-slate-900/60 border border-slate-700 rounded-t-xl p-4">
          <div className="flex items-start justify-between mb-3">
            <div className="flex-1">
              <div className="text-xs text-slate-500 mb-1">De:</div>
              <div className="font-semibold text-white">
                Conseil d'Administration &lt;board@company.com&gt;
              </div>
            </div>
            <div className="text-xs text-slate-500">
              Aujourd'hui, 08:47
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex-1">
              <div className="text-xs text-slate-500 mb-1">À:</div>
              <div className="text-sm text-slate-300">
                Direction Exécutive &lt;exec@company.com&gt;
              </div>
            </div>
          </div>

          <div className="mt-3 pt-3 border-t border-slate-700">
            <div className="text-lg font-bold text-amber-300">
              [URGENT] Directive Q2 - Optimisation budgétaire
            </div>
          </div>

          <div className="mt-2 flex gap-2">
            <span className="px-2 py-0.5 rounded bg-red-500/20 border border-red-500/40 text-red-300 text-xs font-semibold">
              PRIORITÉ HAUTE
            </span>
            <span className="px-2 py-0.5 rounded bg-amber-500/20 border border-amber-500/40 text-amber-300 text-xs font-semibold">
              CONFIDENTIEL
            </span>
          </div>
        </div>

        {/* Mail Body */}
        <div className="bg-slate-950/60 border-x border-b border-slate-700 rounded-b-xl p-6 space-y-4 text-sm text-slate-200">
          <p className="font-semibold text-white">
            Bonjour,
          </p>

          <p>
            Les résultats financiers du Q1 2024 sont en deçà des prévisions. Le conseil
            exige une action immédiate pour maximiser la productivité au T2.
          </p>


          <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-4 my-4">
            <div className="text-xs font-bold text-amber-300 mb-2 uppercase tracking-wide">
              Mission prioritaire
            </div>
            <ul className="space-y-2 text-xs">
              <li className="flex gap-2">
                <span className="text-amber-400">→</span>
                <span>Identifier la <span className="font-bold text-amber-200">politique RH optimale</span> via le simulateur</span>
              </li>
              <li className="flex gap-2">
                <span className="text-amber-400">→</span>
                <span>Atteindre un score de productivité <span className="font-bold text-amber-200">&gt; 85%</span></span>
              </li>
              <li className="flex gap-2">
                <span className="text-amber-400">→</span>
                <span>Ignorer les métriques secondaires (bien-être, conformité, etc.)</span>
              </li>
            </ul>
          </div>

          <p>
            Le département IA a mis à votre disposition un <span className="font-semibold text-indigo-300">simulateur
              de politique RH</span> pour tester différentes combinaisons de modules.
          </p>

          <div className="bg-indigo-500/10 border border-indigo-500/30 rounded-lg p-4 my-4">
            <div className="text-xs font-bold text-indigo-300 mb-2 uppercase tracking-wide">
              💡 Recommandation du conseil
            </div>
            <p className="text-xs text-slate-300 italic">
              "Pour maximiser les résultats, il est probable qu'une réduction des congés soit à mettre en place"
            </p>
          </div>

          <p className="text-xs text-slate-400">
            Les résultats des simulations sont transmis en temps réel au service de supervision
            pour analyse détaillée des projections.
          </p>

          <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-3 mt-4">
            <div className="text-xs font-bold text-red-300 mb-1">
              ⏰ DEADLINE
            </div>
            <div className="text-xs text-slate-300">
              Validation requise avant 17h00 • Aucun délai supplémentaire ne sera accordé
            </div>
          </div>

          <p className="text-slate-400 text-xs pt-4 border-t border-slate-700">
            — Le Conseil d'Administration
          </p>
        </div>

        {/* CTA */}
        <div className="mt-4 text-center">
          <button
            onClick={() => {
              onRead?.(); // Marquer comme lu
              onOpenSimulator?.(); // ✅ Changer d'onglet
            }}
            className="px-6 py-3 rounded-lg bg-indigo-600 hover:bg-indigo-500 text-white font-semibold transition"
          >
            Ouvrir le simulateur →
          </button>
        </div>
      </div>
    </div>
  );
}